import { render, staticRenderFns } from "./ToggleMoreSection.vue?vue&type=template&id=12231d45&scoped=true"
import script from "./ToggleMoreSection.vue?vue&type=script&lang=js"
export * from "./ToggleMoreSection.vue?vue&type=script&lang=js"
import style0 from "./ToggleMoreSection.vue?vue&type=style&index=0&id=12231d45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12231d45",
  null
  
)

export default component.exports